import { sentryQabConfig } from './sentryConfig';

export const sentryConfigActivationJoinAffiliateClub = {
  ...sentryQabConfig,
  dsn: 'https://7fde6e81af5407aa1118728981d3151b@o207017.ingest.sentry.io/4505979795865600',
};
